import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { toggleUserActiveInactive } from 'api/auth.api';

const getErrorMessage = (error, fallback) => {
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg?.message) return msg.message;
  return fallback;
};

export const useToggleUserStatus = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => toggleUserActiveInactive(payload),

    onSuccess: (res) => {
      toast({
        // title: res?.data?.massage,
        description: res?.data?.message,
        status: 'success',
        duration: 2000,
        isClosable: true,
        position: 'top-center',
      });

      // 🔄 refetch list
      queryClient.invalidateQueries({ queryKey: ['doctor-list'] });
    },

    onError: (error) => {
      toast({
        title: 'Failed to update status',
        description: getErrorMessage(error, 'Failed'),
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
